import { get } from 'lodash/fp';
import { createSelector } from 'reselect';

export const getReservationCreate = get('reservation.routes.create');

export const getIsSaving = createSelector(getReservationCreate, get('saving'));

export const getIsSaved = createSelector(getReservationCreate, get('saved'));

export const getActivePanel = createSelector(
  getReservationCreate,
  get('activePanel')
);
